<template>
	<div>
		<topTab ref="topTab" :tabData='tabData' @tabChange='changePages'>
			<div v-if="activeTab === '1'">
				<el-form :inline="true" :model="formInline" class="user-search">
					<el-form-item label="模块名称：">
						<el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.menuName"
							placeholder="请输入模块名称"></el-input>
					</el-form-item>
					<el-form-item label="模块编号：">
						<el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.menuCode"
							placeholder="请输入模块编号"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">
							搜索
						</el-button>
						<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
					</el-form-item>
					<el-form-item style="float: right;margin-right: 0;">
						<el-button size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增
						</el-button>
						<!-- <el-button size="small" plain icon="el-icon-search">高级筛选</el-button> -->
						<my-column-filter :listColumns="listColumns" @hidePop="getCheckBox"></my-column-filter>
					</el-form-item>
				</el-form>
				<!--列表-->
				<STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
					max-height="650" height="650" :rowKey="'keyId'" @rowClick="handleRowClick"
					:tree-props="{ children: 'subList', hasChildren: 'hasChildren' }">
					<el-table-column slot="menuIcon" align="center" prop="menuIcon" label="模块图标">
						<template slot-scope="scope">
							<i :class="['al-iconfont', scope.row.menuIcon]" v-if="scope.row.menuType === 3"></i>
							<i :class="scope.row.menuIcon" v-else></i>
						</template>
					</el-table-column>
					<el-table-column slot="menuType" align="center" label="模块类型" prop="menuType" min-width="80">
						<template slot-scope="scope">
							<el-tag class="typeTag" type="primary" v-if="scope.row.menuType === 1">
								web
							</el-tag>
							<el-tag class="typeTag" type="info" v-else-if="scope.row.menuType === 2">
								客户端
							</el-tag>
							<el-tag class="typeTag" type="danger" v-else-if="scope.row.menuType === 3">
								手机端
							</el-tag>
							<el-tag class="typeTag" type="warning" v-else>
								其他
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column slot="menuColor" align="center" label="颜色" prop="menuColor" min-width="80">
						<template slot-scope="scope">
							<el-tag class="colorG" :color="scope.row.menuColor"></el-tag>
						</template>
					</el-table-column>
					<el-table-column slot="isShow" align="center" prop="isShow" label="是否显示">
						<template slot-scope="scope">
							<span @click.stop.prevent>
								<el-switch v-model="scope.row.isShow" active-color="#13ce66" inactive-color=""
									@change="editIsShow(scope.row)">
								</el-switch>
							</span>
						</template>
					</el-table-column>
					<el-table-column slot="isOnLine" align="center" prop="isOnLine" label="是否上线">
						<template slot-scope="scope">
							<span @click.stop.prevent>
								<el-switch v-model="scope.row.isOnLine" active-color="#13ce66" inactive-color=""
									@change="editIsOnLine(scope.row)">
								</el-switch>
							</span>
						</template>
					</el-table-column>
					<el-table-column slot="handle" label="操作" align="center" width="150">
						<template slot-scope="scope">
							<el-button size="mini" type="" icon="el-icon-plus" v-if="scope.row.menuLevel !== 3"
								@click.stop="addModule(scope.row)">新增</el-button>
						</template>
					</el-table-column>
				</STable>
				<!-- 分页组件 -->
				<Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

			</div>

			<div v-if="activeTab === '2'">
				<business ref="business"></business>
			</div>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
		<!-- 按钮 -->
		<editBtn ref="editBtn"></editBtn>
	</div>

</template>

<script>
import {
	GetMenuTreeList,
	DeleteModuleInfo,
	SaveModule,
	SetMenuIsShow,
	SetMenuIsOnLine
} from '../../../api/menuApi.js';
import edit from './edit';
import editBtn from './editBtn.vue';
import business from './business';
export default {
	data() {
		return {
			activeTab: '1',
			tabData: [{
				key: '1',
				value: '菜单配置列表'
			}],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				menuName: ''
			},
			columnsData: [], //显示列
			listColumns: [{
				prop: 'rowNumber',
				label: '序号',
				align: 'center',
				fixed: 'left',
				width: '100',
				isKeep: true
			},
			{
				prop: 'menuName',
				label: '模块名称',
				isKeep: true,
			},
			{
				prop: 'menuCode',
				label: '模块编号',
			},
			{
				prop: 'menuPath',
				label: '模块地址',
			},
			{
				slot: 'menuType',
				label: '模块类型',
			},
			{
				prop: 'seq',
				label: '显示顺序',
			},
			{
				slot: 'menuIcon',
				label: '模块图标'
			},
			{
				slot: 'menuColor',
				label: '颜色'
			},
			{
				slot: 'isShow',
				label: '是否显示'
			},
			{
				slot: 'isOnLine',
				label: '是否上线'
			},
			{
				slot: 'handle',
				isKeep: true,
				label: '操作',
			},
			],
		};
	},
	// 注册组件
	components: {
		edit,
		editBtn,
		business
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map(item => item.label))

		this.getListData();

	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter(v => !val.includes(v.label))
			this.columnsData = this.listColumns.filter(i => !arr.includes(i));
		},
		// 切换
		changePages(tab) {
			this.activeTab = tab;
			if (this.activeTab === '1') {

			} else {
				this.$nextTick(() => {
					this.$refs.business.showEdit();
				})
			}
		},

		//显示编辑界面
		handleEdit(row) {
			this.$refs.edit.editShow(row, 1);
		},

		// 新增子菜单
		addModule(row) {
			if (row.menuLevel === 1) {
				this.$refs.edit.editShow(row, 2);
			} else if (row.menuLevel === 2) {
				this.$refs.editBtn.editShow(row, 'add');
			}
		},

		// 单击行数据
		handleRowClick(row) {
			if (row.menuLevel === 3) {
				this.$refs.editBtn.editShow(row, 'edit');
			} else {
				this.$refs.edit.editShow(row, 1);
			}
		},

		// 设置是否显示
		editIsShow(row) {
			let param = {
				keyId: row.keyId,
				isUse: row.isShow
			}
			SetMenuIsShow(param)
				.then(res => {
					if (res.code === 1) {
						this.$message({
							type: 'success',
							message: '保存成功！'
						})
						setTimeout(() => {
							this.getListData();
						}, 500);
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
				.catch(err => {
					this.loading = false
					this.$message.error('保存失败，请稍后再试！')
				})
		},

		// 设置是否上线
		editIsOnLine(row) {
			let param = {
				keyId: row.keyId,
				isUse: row.isOnLine
			}
			SetMenuIsOnLine(param)
				.then(res => {
					if (res.code === 1) {
						this.$message({
							type: 'success',
							message: '保存成功！'
						})
						setTimeout(() => {
							this.getListData();
						}, 500);
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
				.catch(err => {
					this.loading = false
					this.$message.error('保存失败，请稍后再试！')
				})
		},

		handleCommand(command) {
			switch (command.command) {
				case "1":
					this.addModule(command.rowData)
					break;
				default:
					console.log(command);
			}
		},

		// 获取列表
		getListData() {
			this.loading = true;
			GetMenuTreeList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: 'info',
							message: res.msg,
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error('数据加载失败，请稍后再试！');
				});
		},

		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline
			this.search();
		},

		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},

	},
};
</script>

<style scoped>
.colorG {
	width: 100%;
}

::v-deep .el-switch__core {
	width: 40px !important;
}
</style>